import parsePhoneNumber from 'libphonenumber-js';

export const parseDutchPhoneNumber = (phoneNumber: string) => {
  const parsed = parsePhoneNumber(phoneNumber, 'NL');

  return parsed ? parsed.formatNational() : phoneNumber;
};
